import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';

export type RouteHistoryController = Readonly<{
  back: () => void;
  forward: () => void;
  go: (delta: number) => void;
}>;

// route.history.back();    // -1
// route.history.forward(); // +1
// route.history.go(-2);    // dos entradas atrás
// route.history.go(3);     // tres entradas adelante
export function useUrlHistoryNavigation(): RouteHistoryController {
  const navigate = useNavigate();

  const go = useCallback(
    (delta: number) => {
      if (!Number.isInteger(delta)) {
        throw new TypeError('history.go() requires an integer');
      }

      if (delta === 0) {
        throw new RangeError('history.go() requires a non-zero delta');
      }

      void navigate(delta);
    },
    [navigate]
  );

  const back = useCallback(() => {
    go(-1);
  }, [go]);

  const forward = useCallback(() => {
    go(1);
  }, [go]);

  return useMemo(
    () =>
      Object.freeze({
        back,
        forward,
        go,
      }),
    [back, forward, go]
  );
}
